<template>
  <svg
    role="presentation"
    class="icon"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="cls-1"
      d="M20 4H4C2.89543 4 2 4.89543 2 6V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4Z"
    />
    <path
      class="cls-1"
      d="M22 7L13.03 12.7C12.7213 12.8934 12.3643 12.996 12 12.996C11.6357 12.996 11.2787 12.8934 10.97 12.7L2 7"
    />
  </svg>
</template>

<script>
export default {
  name: 'ContactMailIcon'
}
</script>

<style lang="scss" scoped>
.icon {
  height: 2rem;
  width: 2rem;
}

.cls-1 {
  fill: none;
  stroke: var(--_zenith-header-text-link, var(--zenith-header-text-link));
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 0.833333;
}
</style>
